import { render, staticRenderFns } from "./TimerView.vue?vue&type=template&id=63e542ee&scoped=true&"
import script from "./TimerView.vue?vue&type=script&lang=js&"
export * from "./TimerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e542ee",
  null
  
)

export default component.exports